export const hardwareActions = [
  'Lock',
  'Headlight',
  'Throttle',
  'Saddle',
  'Tailbox',
  'Battery',
  'Restart',
  'Alarm',
  'Dock',
]
